<template>
  <div class="counselor-base" :class="{ vt1: viewType === 1 }">
    <div class="face">
      <img :src="cImageUrlMod" v-if="cImageUrlMod" />
      <span v-else class="noimage">noimage</span>
    </div>
    <div class="c-name">{{ cName }}</div>
    <div class="c-profile">{{ cProf }}</div>
  </div>
</template>

<script>
export default {
  name: "counselor",
  props: {
    cName: {
      type: String,
      default() {
        return ''
      }
    },
    cProf: {
      type: String,
      default() {
        return ''
      }
    },
    cImageUrl: {
      type: String,
      default() {
        return ''
      }
    },
    viewType: {
      type: Number,
      default() {
        return 0
      }
    }
  },
  computed: {
    cImageUrlMod() {
      return this.cImageUrl || ''
    }
  }
}
</script>

<style scoped lang="scss">
@import "../../../../../../sass/variables/index";
.counselor-base {
  $imgSize: 74px;
  flex-basis: $imgSize;
  width: $imgSize;
  height: 100px;
  margin: 8px;

  .face {
    width: $imgSize;
    height: $imgSize;
    display: block;
    border-radius: $imgSize / 2;
    overflow: hidden;
    margin-bottom: 8px;
    img {
      display: block;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    .noimage {
      width: 100%;
      height: 100%;
      font-size: 10px;
      display: flex;
      justify-content: center;
      align-items: center;
      color: $gray-3;
      background: $gray-19;
    }
  }
  .c-name {
    width: 100%;
    text-align: center;
    font-size: 12px;
    line-height: 14px;
    color: $gray-20;
  }
  .c-profile {
    display: none;
  }

  &.vt1 { //横目いっぱいプロフあり
    $imgSize: 65px;
    width: 100%;
    height: auto;
    min-height: $imgSize;
    margin: 0;
    padding: 0 0 0 $imgSize + 15px;
    position: relative;
    text-align: left;
    .face {
      width: $imgSize;
      height: $imgSize;
      border-radius: $imgSize / 2;
      position: absolute;
      top: 0;
      left: 0;
    }
    .c-name {
      color: $gray-20;
      font-weight: bold;
      text-align: left;
      margin-bottom: 8px;
    }
    .c-profile {
      font-size: 11px;
      line-height: 16px;
      color: $gray-21;
      display: block;
    }

  }

}

</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/YearLuck/y2020/partials/counselor.vue